import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { courseTasksService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as courseTasksActions from './actions';

export function getCourseTasks(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_TASKS),
    mergeMap(({ payload }) => {
      return courseTasksService.getCourseTasks(payload).pipe(
        map((res) => courseTasksActions.getCourseTasksSuccess(res.responceObject.records)),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
